import "./FormStyles.css";
import { FaFacebook, FaGithub, FaHome, FaLinkedin, FaMailBulk, FaPhone} from "react-icons/fa"

import React from 'react'


export const Form = () => {
  return (
    <div className="form">
        <div className="footer-container">
                <div className="left">
                    <div className="location">
                        <FaHome  size={20} 
                        style={{color:"#fff", marginRight:"2rem"}}/>

                        <div>
                            <p>Sura Tilona, Satsang</p>
                            <p>Deoghar, Jharkhand</p>
                        </div>
                    </div>
                    <div className="phone">
                        <FaPhone size={20} 
                        style={{color:"#fff", marginRight:"2rem"}}/>
                        <h4>+91  9006318091</h4>
                    </div>

                    <div className="email">
                        <FaMailBulk size={20} 
                        style={{color:"#fff", marginRight:"2rem"}}/>
                        <p>raje754912@gmail.com</p>
                    </div>
                </div>


                <div className="right">
                    <h4>Connect with me</h4>

                    
                    <div className="social">
                       <a href="https://www.facebook.com/profile.php?id=100027103459167" target={"_blank"} rel="noopener noreferrer"> <FaFacebook size={50} 
                            style={{color:"blue", marginRight:"1rem"}}/></a>
                        
                        <a href="https://github.com/rajeshdeo" target={"_blank"} rel="noopener noreferrer"><FaGithub size={50} 
                            style={{color:"blue", marginRight:"1rem"}}/></a>
                            
                        <a href="https://www.linkedin.com/in/rajesh-kumar-801161258/" target={"_blank"} rel="noopener noreferrer"><FaLinkedin size={50} 
                            style={{color:"blue", marginRight:"1rem"}}/></a>
                            
                    </div>

                    
                </div>
                
            </div>
        {/* <h2 style={{textAlign:"center",color:"green",marginTop:"2rem"}}>Want to hire me</h2>
         <form> 
            <label>Your Name</label>
            <input type="text"></input>
            <label>Email</label>
            <input type="email"></input>
            <label>Subject</label>
            <input type="text"></input>
            <label>Message</label>
            <textarea row="6" placeholder="Type message here" />
            <button className="btn">Submit</button>
        </form> */}
    </div>
  )
}
